import React, { useEffect } from "react";
import Collapsible from "../../../components/shared/Collapsible";
import { ServiceProjects } from "../../../services/service-projects";
import appState from "../../../state/AppStateContainer";
import moment from "moment";
import BidIntentControls, { BidIntentStatus } from "../BidIntentControls/BidIntentControls";
import { ServiceQuotation } from "../../../services/service-quotation";
import BtButton from "../../bt-button/bt-button";
import ShowMoreText from "../../../components/shared/ShowMoreText";
import HTMLParser from "../../../components/shared/HTMLParser/HTMLParser";
import { DemandsContainer, LabeledBLock } from "../StaticComponents";
import fileDownload from "js-file-download";
import _ from "lodash";
import { ReactComponent as ShareIcon } from '../../../assets/svg/shareIcon.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/svg/calendarIcon.svg';
import { ReactComponent as ClipIcon } from '../../../assets/svg/clip.svg';
import { ErrorMessageIcon } from "../../../components/shared/ErrorMessageIcon/ErrorMessageIcon";
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ical from "ical-generator";
import { btHasObject } from "../../../utils/bt-array";
import { formatPrice } from "../../../util";
import Selector from "../../../components/shared/Selector/Selector";
import { NotificationManager } from 'react-notifications';
import $ from 'jquery';
import './CollapsibleView.scss';
import { ServiceSupplier } from "../../../services/service-supplier";
import Modal from "../../../components/shared/Modal/Modal";
import TitleWrapper from "../../../components/shared/TitleWrapper/TitleWrapper";
import QuoteSharingModal from "../QuoteSharingModal/QuoteSharingModal";
import { getUID } from '../../../global/app';
import DatePicker from "react-datepicker";
import helperImage from "../../../assets/images/help.png"
import TooltipContainer from "../../../components/shared/TooltipContainer/TooltipContainer";
import Spinner from "../../../components/shared/Spinner/Spinner";
import DownloadButton from "../../../components/shared/DownloadButton";
import File from "../../../components/File/File";
import BtRow from "../../bt-row/bt-row";
import BtColumn from "../../bt-column/bt-column";
import { FileScope } from "../../../util/appEnum";
import Field from "../../../components/shared/Field/Field";
import StyledCheckbox from "../../../components/shared/StyledCheckbox/StyledCheckbox";
import Editor from "../../../components/shared/Editor/Editor";
import { withTranslation } from "react-i18next";
import serviceFiles from "../../../services/service-files";
import FileArea from "../../page-files/FileArea";
import BannerCard from "../../../components/shared/BannerCard/BannerCard";

const quotationValidityOptions = [30, 60, 90];

function replaceOrAppendBidFilesTempSegment(rootPath, tempFolderName) {
  const re = /\/temp-[^/]+/;
  if (re.test(rootPath)) {
    return rootPath.replace(re, `/${tempFolderName}`);
  }
  return `${rootPath}/${tempFolderName}`;
}

class CollapsibleView extends React.Component {
  elInputFile;

  constructor(props) {
    super(props);
    this.state = {
      showInfo: true,
      supplierData: [],
      supplieBidForm: [],
      projectAreaData: [],
      projectData: [],
      quotationAttachments: [],
      quotationDemands: [],
      files: [],
      newFiles: [],
      quoteMessageContent: '',
      reservationContent: '',
      price: '',
      supplierId: '',
      quotationId: '',
      processForm: false,
      fileAreaUploading: false,
      demands: [],
      demandsError: '',
      supplierPriceDetails: [],
      showBidDeclinedModal: false,
      bidDeclinedReason: '',
      previousBidIntent: null,
      quotationValidity: '',
      showRequestShareModal: false,
      quoteSharingBtnLoader: false,
      openView: props.openView,
      isSubmittingRejectingIntent: false,
      fileAreaPath: '/',
      bidFileAreaPath: '/',
      tempSupplierBidFileAreaRoot: undefined,
    };
    this.quotationDataNode = React.createRef(null);
  }

  componentDidMount() {
    const { versionData, isPublished } = this.props;
    this.setState({ allVersions: versionData });
    this.setQuotationData(versionData);
    this.buildTempFilePaths(versionData);

    // Update seen status only when supplier expand the collapsible view
    if (this.props.openView && !isPublished) this.updateQuotationIsSeenStatus(versionData);
  }

  componentDidUpdate(prevProps) {
    const { versionData } = this.props;
    const { versionData: oldVersionData } = prevProps;
    if (!_.isEqual(versionData, oldVersionData)) {
      this.setQuotationData(versionData);
    }
  }

  buildTempFilePaths = async (versionData) => {
    const { status, quotation, quoteVersionNo, supplier, supplierBid, quoteRefId } = versionData;
    const versionNumber = parseInt(versionData.quoteVersionNo + 1);
    const { project: projectData, area: projectAreaData } = quotation;
    const { isPublished } = this.props;

    const computedBidFilesRoot = `/bid-files/${projectData.id}/${projectAreaData._id}/${versionNumber}/${supplier._id}`;
    const supplierBidFileAreaRoot =
      supplierBid?.fileAreaBidFiles ||
      computedBidFilesRoot;

    if (status.isLocked) {
      this.setState({ tempSupplierBidFileAreaRoot: supplierBidFileAreaRoot, fileAreaPath: '/' });
      return;
    }

    const tempRoot = replaceOrAppendBidFilesTempSegment(
      supplierBidFileAreaRoot,
      `temp-${Date.now()}`,
    );

    if (supplierBid?.fileAreaBidFiles) {
      await serviceFiles.copyFileArea(supplierBid.fileAreaBidFiles, tempRoot, { ttl: true, quotationId: isPublished ? quoteRefId : undefined });
    }

    this.setState({ tempSupplierBidFileAreaRoot: tempRoot, fileAreaPath: '/' })
  }

  updateQuotationIsSeenStatus = quoteData => {
    const { quoteRefId, supplier, quoteVersionNo, quotation, supplierMemberId } = quoteData;
    if (supplierMemberId && appState.isSupplierRole()) {
      const payload = {
        quoteRefId,
        supplierId: supplier._id,
        quotationId: quotation.id,
        areaId: quotation.area,
        quoteVersionNo,
        supplierMemberId,
      };
      ServiceQuotation.updateQuotationIsSeen(payload);
    }
  };

  setQuotationData(quotationData) {
    let demands = [];
    if (quotationData && quotationData.supplierBid && quotationData.supplierBid.demands) {
      let mapQuotationDemands = quotationData.quotation.demands.map(d => {
        return { demandId: d.demandId._id };
      });
      demands = quotationData.supplierBid.demands.filter(demand => {
        return btHasObject(mapQuotationDemands, 'demandId', demand.demandId);
      });
    }
    this.setState({
      supplierSlug: quotationData.supplierSlug,
      supplierSlugForReal: quotationData.supplier?.slug,
      supplierMemberId: quotationData.supplierMemberId,
      quotationData: quotationData.quotation,
      supplierData: quotationData.supplier,
      supplieBidForm: quotationData.supplierBid,
      projectAreaData: quotationData.quotation.area,
      projectData: quotationData.quotation.project,
      quotationAttachments: quotationData.quotation.attachments,
      quotationDemands: quotationData.quotation.demands,
      files: quotationData.supplierBid ? quotationData.supplierBid.attachments : [],
      quoteMessageContent: quotationData.supplierBid ? quotationData.supplierBid.message ?? null : null,
      reservationContent: quotationData.supplierBid ? quotationData.supplierBid.content ?? null : null,
      price: quotationData.supplierBid ? quotationData.supplierBid.price : null,
      supplierId: quotationData.supplier?._id,
      quotationId: quotationData.quotation.id,
      supplierPriceDetails:
        quotationData.supplierBid && !_.isEmpty(quotationData.supplierBid.priceDetails)
          ? quotationData.supplierBid.priceDetails.map(x => ({
            priceType: x.priceType.name,
            price: formatPrice(x.price || 0),
            _id: x.priceType._id,
          }))
          : quotationData.quotation.priceDetails.map(x => ({
            priceType: x.priceType.name,
            price: formatPrice(x.price || 0),
            _id: x.priceType._id,
          })),
      demands: demands,
      quoteVersionNo: quotationData.quoteVersionNo,
      quoteRefId: quotationData.quoteRefId ? quotationData.quoteRefId : '',
      status: quotationData.status,
      intentStatus: quotationData?.intentStatus?.intent || BidIntentStatus.UNDECIDED,
      wasEverSubmitted: quotationData.wasEverSubmitted,
      quotationValidity: this.setQuotationValidity(quotationData?.supplierBid?.quotationValidity),
    });
  }

  toggleRequestShareModal = () => {
    this.setState({ showRequestShareModal: !this.state.showRequestShareModal });
  };

  setQuotationValidity = value => {
    return typeof value === 'string' ? new Date(value) : '';
  };

  renderQuotationInfo = quote => {
    const { t } = this.props;
    const { status, quotation, quoteVersionNo, supplier } = quote;
    const { project: projectData, area: projectAreaData } = quotation;
    const isPublished = this.props.isPublished;
    const versionNumber = Number(quoteVersionNo) + 1;
    const canEditFileAreas = (appState.isWriteAccessRole() && !status.isLocked);
    const bidFileAreaRoot = quotation.fileAreaBidRequestFiles || '/bid-files/empty';

    const isFormDisabled = (bidStatus = this.state.status) => {
      return appState.isReadOnlyAccessRole() || bidStatus?.isLocked || this.state.fileAreaUploading;
    }

    const isDisabled = isFormDisabled();
    const { openView } = this.state;


    const unlockBidForm = async () => {
      try {
        await ServiceProjects.unlockBidForm(
          projectData.slug,
          projectAreaData._id,
          supplier._id,
          quoteVersionNo,
        );
        const nextStatus = { ...status, reason: 'Unlocked', isLocked: false, unlockedAt: new Date() };
        const versionDataForPaths = {
          ...this.props.versionData,
          status: nextStatus,
        };
        await this.buildTempFilePaths(versionDataForPaths);
        this.setState({
          status: nextStatus,
          fileAreaPath: '/',
        });
      } catch (error) {
        NotificationManager.error(t('notification.error.unknown', 'Oväntat fel ({{error}})', { error }));
        throw error;
      }
    };

    const formatDate = date => {
      return date && moment(date).format('D MMMM YYYY');
    };

    const getDatePart = (bidStatus = this.state.status) => {
      const hasDateExpiredOnce = moment(status.expirationDate).isBefore(new Date());
      if (bidStatus.submittedAt) {
        return t('statusMessage.submittedAt', 'Besvarad {{date}}', { date: formatDate(bidStatus.submittedAt) });
      } else if (bidStatus.reason == 'Expired' || hasDateExpiredOnce) {
        return t('statusMessage.expiredAt', 'Utgånget den {{date}}', { date: formatDate(bidStatus.expirationDate) });
      }
      return t('statusMessage.expirationAt', 'Utgångsdatum den {{date}}', { date: formatDate(bidStatus.expirationDate) });
    };

    const showClockIcon = () => {
      const { status } = this.state;
      if (status.reason == 'NotLatestVersion' && !status.submittedAt) return;
      return <AccessTimeIcon fontSize="small" />;
    }

    const getStatusMessage = (bidStatus = this.state.status) => {
      let statusMessage = '';
      if (bidStatus.reason == 'NotLatestVersion') {
        if (bidStatus.submittedAt) {
          statusMessage += getDatePart(bidStatus) + ' ';
        } else {
          statusMessage = t('statusMessage.notLatestVersion', 'Endast senaste versionen går att skicka in.');
        }
      } else if (appState.isReadOnlyAccessRole()) {
        statusMessage = getDatePart(bidStatus);
      } else {
        statusMessage = getDatePart(bidStatus) + (bidStatus.reason == 'Unlocked' ? ' ' + t('statusMessage.unlocked', 'Anbudsformuläret är upplåst.') : '');
      }
      return statusMessage;
    };

    const renderIntentSelector = () => {
      const { intentStatus } = this.state;

      return (
        <div className="page-quotation-status-div">
          {(appState.isSupplierRole() || appState.isWriteAccessRole()) && (
            <BidIntentControls
              status={intentStatus}
              onChange={async value => {
                if (intentStatus != value) {
                  if (value === BidIntentStatus.DECLINED) {
                    this.setState({
                      previousBidIntent: intentStatus,
                      intentStatus: value,
                      showBidDeclinedModal: true,
                    });
                  } else {
                    this.setState({ intentStatus: value });
                    try {
                      await ServiceQuotation.updateBidIntent(
                        projectData.slug,
                        projectAreaData.slug,
                        supplier._id,
                        parseInt(quoteVersionNo),
                        { intent: value, reasonDeclined: '' },
                        this.state.supplierMemberId
                      );
                      NotificationManager.success(t('notification.success.bidIntentSaved', 'Tack! Din avsiktsförklaring är sparad.'));
                    } catch (error) {
                      NotificationManager.error(t('notification.error.unknown', 'Oväntat fel ({{error}})', { error }))
                      throw error;
                    }
                  }
                }
              }}
            />
          )}
        </div>
      );
    };

    const fileViewer = (item, i) => {
      const { showAllAttachedFiles } = this.state;
      return (
        <File
          key={item.fileId}
          file={item.fileId || item.fileName}
          fileName={item.fileName}
          disabled={!item.fileId}
          scope={FileScope.BidRequestAttachment}
          scopeOptions={{
            quotationId: this.props?.versionData?.quoteRefId,
            versionNumber: this.props?.versionData?.quoteVersionNo,
          }}
        />
      );
    };

    const generateCalendarFile = () => {
      const calendar = ical();
      calendar.createEvent({
        allDay: true,
        start: moment(this.state?.status?.expirationDate),
        summary: t(
          'calendar.event.summary',
          '{{area}} till {{project}}, {{orgName}} - Sista dagen att lämna anbud',
          {
            area: this.state.projectAreaData.name,
            project: this.state.projectData.name,
            orgName: appState.getCurrentOrgName()
          }
        ),
        description: t(
          'calendar.event.description',
          'Öppna anbudssidan i Accurator<{{href}}>',
          { href: window.location.href }
        )
      });

      return calendar.toString()
    }

    const renderContentBlock2 = () => {
      const { status } = this.state;
      const isDisabled = isFormDisabled();
      const userName = appState.getUserName();

      const downloadCalendarFile = () => fileDownload(
        generateCalendarFile(),
        'AccuratorEvent',
        'text/calendar'
      );

      const openRequestShareModal = async () => {
        const { supplierData } = this.state;
        const userId = appState.getUserId();
        this.toggleRequestShareModal();
        this.setState({ showRequestShareModal: true, fetchingSupplierMembers: true });
        let supplierMembers = [];
        if (supplierData?._id) {
          supplierMembers = await ServiceSupplier.getSupplierMembers(supplierData?._id);
          supplierMembers = supplierMembers.filter(member => member._id !== userId);
        }
        this.setState({ supplierMembers, fetchingSupplierMembers: false });
      };

      return (
        <div className="padded-block content-block2">
          <div className="sub-block">
            <span><PersonOutlineIcon fontSize="small" /> {t('title.share', 'Svarar som {{userName}}', { userName })}</span>
            {!isPublished && (
              <BtButton size='xxs' color='white' disabled={isDisabled} onClick={!isDisabled ? openRequestShareModal : undefined} leftIcon={<ShareIcon style={{ color: 'var(--gray-700)' }} fontSize="small" />} className="quotation-share-button">
                {t('button.share', 'Dela förfrågan')}
              </BtButton>
            )}
          </div>
          <div className="sub-block">
            <span>{showClockIcon()}{getStatusMessage()}</span>

            {(!isDisabled && status.expirationDate && moment(status.expirationDate).diff(new Date(), 'days') >= 0) && (
              <div className="calendar-wrapper">
                <TooltipContainer delayed renderReferenceComponent={(className, ref) =>
                  <BtButton class={className} ref={ref} size='xxs' color='white' leftIcon={<CalendarIcon style={{ fill: 'var(--gray-700)', width: '15px' }} />} onClick={downloadCalendarFile}>
                    {t('calendar.button.add', 'Lägg till i kalender')}
                  </BtButton>
                }>
                  <p style={{ width: "300px" }}>
                    {t('calendar.tooltip', 'Klicka för att ladda ner en händelse som .ics-fil. Öppna .ics-filen för att lägga till händelsen i din kalender, t.ex. Outlook. Om du vill att .ics-filer alltid ska öppnas i din kalender, kan du kryssa för “Öppna alltid filer av den här typen” i Chrome.')}
                  </p>
                  <img src={helperImage} width="300px" style={{ borderRadius: '8px' }} />
                </TooltipContainer>
              </div>
            )}

            {openView && shouldButtonBeVisible() && (
              <BtButton
                size='xxs'
                color='white'
                onClick={unlockBidForm}
                leftIcon={<LockOpenOutlinedIcon style={{ width: '18px' }} />}
              >
                {t('button.unlock', 'Lås upp')}
              </BtButton>
            )}
          </div>
        </div>
      );
    };

    const onToggleFileViewer = () => {
      const { quotationAttachments } = this.state;
      if (quotationAttachments?.length) {
        this.setState({ showAllAttachedFiles: !this.state.showAllAttachedFiles });
      }
    };

    const renderContentBlock3 = () => {
      const {
        quotationData,
        showAllAttachedFiles,
        projectData,
        projectAreaData,
        supplierData,
        quoteVersionNo
      } = this.state;
      const { slug: projectSlug, name: projectName } = projectData;
      const { slug: areaSlug, name: areaName } = projectAreaData;
      const { _id: supplierId } = supplierData ?? {};

      const quoteAttachments = quotationData?.attachments;
      const hasMoreThan3Documents = quoteAttachments?.length > 3;

      return (
        <div className="padded-block content-block3" style={{ paddingBottom: '16px' }}>
          <LabeledBLock label={t('title.information', 'Information')} containerClass="information ">
            <ShowMoreText>
              <HTMLParser data={quotationData?.content} />
            </ShowMoreText>
          </LabeledBLock>
          <LabeledBLock
            label={t('title.files', 'Handlingar')}
            containerClass="files-container"
          >
            <FileArea
              root={`${bidFileAreaRoot}`}
              path={this.state.bidFileAreaPath}
              setPath={(getNewPath) => {
                const newPath = getNewPath(this.state.bidFileAreaPath);
                this.setState({ bidFileAreaPath: newPath });
              }}
              isAllowedToUpload={false}
              isAllowedToDownload={appState.isSupplierRole() || appState.isCustomerUser()}
              isAllowedToDelete={false}
              quotationId={isPublished ? this.props?.versionData?.quoteRefId : undefined}
            />
            <div className="files-viewer-container">{quoteAttachments?.map(fileViewer)}</div>
            {quoteAttachments?.length > 0 && (
              <DownloadButton
                url={ServiceQuotation.getDownloadQuotationFilesInZipURL({
                  projectSlug,
                  areaSlug,
                  supplierId,
                  versionNumber: quoteVersionNo,
                  orgId: quotationData.area.orgId,
                })}
                fileName={t(
                  'files.fileName',
                  '{{projectName}} - {{areaName}} - V{{version}} - Handlingar.zip',
                  { projectName, areaName, version: quoteVersionNo + 1 }
                )}
                render={({ downloading, progress, onClick }) => (
                  downloading ? (
                    <div className="zipDownloadProgressContainer" onClick={onClick}>
                      <span>{progress === 0 ? t('files.progress.preparing', 'Förbereder') : t('files.progress.downloading', 'Laddar ner')}</span>
                      <Spinner progress={progress} />
                    </div>
                  ) : (
                    <div className="bottom-text" onClick={onClick}>
                      {t('files.download', 'Ladda ner alla handlingar som .zip')}
                    </div>
                  )
                )}
              />
            )}
          </LabeledBLock>
        </div>
      );
    };

    const shouldButtonBeVisible = () => {
      return !!(appState.isWriteAccessRole() && this.state.status.isLocked && !this.props.isPublished);
    };

    const renderFormContent = () => {
      const isDisabled = isFormDisabled();
      const { reservationContent, quoteMessageContent, demands, quotationDemands, quotationData, quotationValidity } = this.state;

      const btCheckClickHandler = target => {
        var demands = this.state.demands;
        var index = demands.findIndex(demand => {
          return demand.demandId == target.demandId._id;
        });
        if (index == -1) {
          demands.push({ demandId: target.demandId._id, required: target.required });
        } else if (index > -1) {
          demands.splice(index, 1);
        }
        let demandsError = this.state.demandsError;
        if (this.state.demands.length > 0) {
          demandsError = '';
        }
        this.setState({ demands: [...demands], demandsError: demandsError });
      };

      const renderDemands = () => {
        const items = quotationDemands?.map((item, key) => (
          <li data-uid={key} className="page-quotation-industry-item" key={key}>
            <label className='page-quotation-demands-label' style={{ cursor: isDisabled ? 'not-allowed' : 'pointer', pointerEvents: isDisabled ? 'none' : 'auto', color: 'var(--gray-900)' }}>
              <StyledCheckbox
                checked={btHasObject(demands, 'demandId', item.demandId._id)}
                onClick={() => !isDisabled ? btCheckClickHandler(item) : null}
              />
              {item.demandId.name}
              {item.required && <span style={{ color: 'var(--orange-500)', marginRight: '8px' }}>*</span>}
              <ErrorMessageIcon errorMessageStyles={{ whiteSpace: 'nowrap' }} style={{ width: 'fit-content', display: 'inline-block' }} errorMessage={item.errorMessage} />
            </label>
          </li>
        ));
        return <ul className="page-quotation-industry-items">{items}</ul>;
      };

      const elBtnAttachClickCallback = () => {
        this.elInputFile.click();
      };

      const getFileObject = (item) => {
        return {
          id: getUID(),
          fileId: item.fileId || item._id,
          fileName: item.name || item.fileName,
          mimeType: item.mimeType,
          fileObj: item._id ? {} : item,
        };
      }

      const uploadItemRemoveClickCallback = index => {
        if (this.state.files && this.state.files.length > 0) {
          var file = this.state.files[index];
          delete this.state.newFiles[file.id];
          this.state.files.splice(index, 1);

          this.setState({
            files: [...this.state.files],
            newFiles: this.state.newFiles,
          });
        }
      };

      const elInputFileChangeCallback = e => {
        var arr = [];
        var files = e.target.files;
        for (let i = 0; i < files.length; i++) {
          var fileObj = getFileObject(files[i]);
          arr.push(fileObj);
          this.state.newFiles[fileObj.id] = fileObj;
        }
        this.setState({
          files: [...this.state.files, ...arr],
          newFiles: this.state.newFiles,
        });
      };

      const renderEditor = (title, editorValue, onChange, attachFile,) => {
        const isDisabled = isFormDisabled();
        const {
          projectData,
          projectAreaData,
          supplierData,
          quoteVersionNo,
          files,
          status,
        } = this.state;

        const { slug: projectSlug, name: projectName } = projectData;
        const { slug: areaSlug, name: areaName } = projectAreaData;
        const { _id: supplierId } = supplierData ?? {};

        const canEditFileAreasLive = (appState.isWriteAccessRole() && !status.isLocked);

        return (
          <BtRow>
            <BtColumn className="app-chat-mail-batch quotation-main-box">
              <span style={{ marginBottom: '8px' }} className="headline-label">{title}</span>
              <div className="message">
                <div className="message-wrapper" id="quotation-editor-wrapper">
                  <div>
                    <Editor
                      value={editorValue}
                      onChange={onChange}
                      isDisabled={isDisabled}
                      wrapperStyle={{ height: '291px' }}
                    />
                  </div>
                </div>
                {attachFile && (<LabeledBLock
                  label={t('title.attachments', 'Bilagor')}
                  containerClass="attachments-container"
                >
                  {attachFile && this.state.tempSupplierBidFileAreaRoot && (
                  <div style={{ display: 'flex', gap: '10px', flexDirection: 'column', marginTop: '10px' }}>
                    <FileArea
                      key={`${this.state.tempSupplierBidFileAreaRoot}-${String(status.isLocked)}`}
                      root={this.state.tempSupplierBidFileAreaRoot}
                      path={this.state.fileAreaPath}
                      setPath={(getNewPath) => {
                        const newPath = getNewPath(this.state.fileAreaPath);
                        this.setState({ fileAreaPath: newPath });
                      }}
                      isAllowedToUpload={(appState.isSupplierRole() && !status.isLocked) || canEditFileAreasLive}
                      isAllowedToDownload={appState.isSupplierRole() || appState.isCustomerUser()}
                      isAllowedToDelete={(appState.isSupplierRole() && !status.isLocked) || canEditFileAreasLive}
                      hasTtl={!(appState.isWriteAccessRole() || status.isLocked || status.submittedAt)}
                      quotationId={isPublished ? this.props?.versionData?.quoteRefId : undefined}
                      onUploadingChange={(isUploading) => this.setState({ fileAreaUploading: isUploading })}
                    />
                    <div className="quote-file-upload-container">

                      {/* <div
                      className="btn-attach-wrapper"
                      onClick={elBtnAttachClickCallback}
                      style={{ padding: 0 }}
                    >
                      <div style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}>
                        <input
                          type="file"
                          multiple
                          onClick={event => {
                            event.target.value = null;
                          }}
                          onChange={!isDisabled ? elInputFileChangeCallback : null}
                          disabled={isDisabled}
                          ref={el => (this.elInputFile = el)}
                        />
                        <BtButton color='white' size='xxs' leftIcon={<ClipIcon style={{ fill: isDisabled ? 'var(--gray-500)' : '' }} />} disabled={isDisabled}>{
                          t('button.attachFile', 'Ladda upp bilaga, t.ex. offert')
                        }</BtButton>
                      </div>
                    </div> */}
                        <div className="quotation-uploaded-files">
                        {files?.map((file, index) => <File
                          key={file._id}
                          file={file?.fileId || ''}
                          fileName={file.fileName}
                          blob={!file?.fileId && file.fileObj}
                          onRemove={!isDisabled ? (() => uploadItemRemoveClickCallback(index)) : undefined}
                          scope={FileScope.BidResponseAttachment}
                          scopeOptions={{
                            quotationId: this.props?.versionData?.quoteRefId,
                            versionNumber: this.props?.versionData?.quoteVersionNo,
                            supplierId: this.props?.versionData?.supplier?._id
                          }}
                        />)}
                        {status.isLocked && files?.length > 0 && (
                          <DownloadButton
                            url={ServiceQuotation.getDownloadQuotationResponseFilesInZipURL({
                              projectSlug,
                              areaSlug,
                              supplierId,
                              versionNumber: quoteVersionNo,
                              orgId: this.props?.versionData?.quotation?.area?.orgId,
                            })}
                            fileName={t(
                              'files.fileName',
                              '{{projectName}} - {{areaName}} - V{{version}} - Handlingar.zip',
                              { projectName, areaName, version: quoteVersionNo + 1 }
                            )}
                            render={({ downloading, progress, onClick }) => (
                              downloading ? (
                                <div className="zipDownloadProgressContainer" onClick={onClick}>
                                  <span>{progress === 0 ? t('files.progress.preparing', 'Förbereder') : t('files.progress.downloading', 'Laddar ner')}</span>
                                  <Spinner progress={progress} />
                                </div>
                              ) : (
                                <div style={{ marginTop: 0 }} className="bottom-text" onClick={onClick}>
                                  {t('files.download', 'Ladda ner alla handlingar som .zip')}
                                </div>
                              )
                            )}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
                </LabeledBLock>)}

              </div>
            </BtColumn>
          </BtRow>
        );
      };

      const savePrice = (name, price, id, required) => {
        // TODO : we need to show update the price if object exist otherwise we need push a create a object
        const isSupplierPriceAlreadyExist = this.state.supplierPriceDetails.filter(
          x => x.priceType === name,
        );
        if (!_.isEmpty(isSupplierPriceAlreadyExist)) {
          this.setState({
            [name]: '',
            supplierPriceDetails: this.state.supplierPriceDetails.map(el =>
              el.priceType === name ? { ...el, price } : el,
            ),
          });
        } else {
          this.setState({
            [name]: '',
            supplierPriceDetails: [
              ...this.state.supplierPriceDetails,
              {
                price,
                priceType: name,
                required: required,
                _id: id,
              },
            ],
          });
        }
      };

      const formatInput = (price = '') => {
        price = JSON.stringify(price);
        var pp = +price.replace(/\D/g, '');
        var tt = pp.toLocaleString();
        tt = tt.replace(new RegExp(',', 'g'), '.');
        return tt == 0 ? '' : tt;
      }

      const getFieldInfo = value => {
        const valueObj = this.state.supplierPriceDetails?.find(f => f?.priceType === value);
        if (valueObj?.priceType) {
          return {
            price: valueObj.price,
            errorMessage: valueObj.errorMessage,
          };
        }
        return {
          price: '',
          errorMessage: '',
        }
      };

      const renderPriceColumn = pd => {
        const isDisabled = isFormDisabled();
        const fieldInfo = getFieldInfo(pd.priceType.name);
        return (
          <Field
            label={pd.priceType.name}
            onChange={(value) => savePrice(pd.priceType.name, value, pd.priceType._id, pd.required)}
            value={formatInput(fieldInfo.price)}
            disabled={isDisabled}
            errorMessage={fieldInfo.errorMessage}
            required={pd.required}
            unit={pd.unit}
          />
        );
      };
      const onQuoteMessageContentChange = quoteMessageContent => {
        this.setState({ quoteMessageContent: quoteMessageContent });
      }

      const onReservationContentChange = reservationContent => {
        this.setState({ reservationContent: reservationContent });
      }

      const getEditorStateContent = editorState => {
        const isEmpty = str => $.trim($('<div>' + str + '</div>').text()) === '';
        return (isEmpty(editorState) || editorState === null) ? '' : editorState;
      };

      const unformatPrice = (formattedPrice = '') => {
        const decimalSeparatedArray = formattedPrice.toString().split(',');
        return decimalSeparatedArray[0].replace(/[.\D]/g, '');
      };

      const saveQuotation = async () => {
        const {
          files,
          newFiles,
          price,
          quoteMessageContent,
          demands,
          quotationData,
          reservationContent,
          quotationValidity,
        } = this.state;

        let quotationDemands = this.state.quotationDemands.map(demand => ({ ...demand, errorMessage: '' }));
        let supplierPriceDetails = this.state.supplierPriceDetails.map(priceField => ({ ...priceField, errorMessage: '' }));

        this.setState({ demandsError: null, processForm: true, quotationDemands, supplierPriceDetails });

        if (
          _.isEmpty(files) &&
          _.isEmpty(newFiles) &&
          !price &&
          (quoteMessageContent == 'null' || !quoteMessageContent) &&
          _.isEmpty(supplierPriceDetails) &&
          _.isEmpty(demands)
        ) {
          this.setState({ processForm: false });
          return NotificationManager.error(
            t('notification.error.emptyBid.description', 'Du kan inte lämna in ett tomt bud.'),
            t('notification.error.emptyBid.title', 'Misslyckat')
          );
        }

        const requiredDemandsNotFilledIn = quotationDemands.some(quotationDemand => quotationDemand.required && !demands.find(demand => demand.demandId === quotationDemand.demandId._id));

        if (requiredDemandsNotFilledIn) {
          quotationDemands = quotationDemands.map(quotationDemand => {
            if (quotationDemand.required && !demands.find(demand => demand.demandId === quotationDemand.demandId._id)) {
              return {
                ...quotationDemand,
                errorMessage: t('validation.requiredDemands', 'Obligatoriskt skallkrav'),
              }
            }
            return quotationDemand
          });
        }

        const requiredPriceFieldsNotFilledIn = quotationData.priceDetails.some(quotationPriceDetail => quotationPriceDetail.required && supplierPriceDetails.find(priceDetail => priceDetail._id === quotationPriceDetail.priceType._id)?.price === '');

        if (requiredPriceFieldsNotFilledIn) {
          supplierPriceDetails = supplierPriceDetails.map(supPriceDetail => {
            const foundRequiredField = quotationData.priceDetails.find(priceDetail => supPriceDetail._id === priceDetail.priceType._id && priceDetail.required);
            if (foundRequiredField && supPriceDetail?.price === '') {
              return {
                ...supPriceDetail,
                errorMessage: t('validation.requiredPriceFields', 'Obligatoriskt prisfält'),
              }
            }
            return supPriceDetail
          });
        }
        if (requiredDemandsNotFilledIn || requiredPriceFieldsNotFilledIn) {
          const missingFields = [
            requiredPriceFieldsNotFilledIn ? t('notification.error.missingField.priceField', 'prisfält') : '',
            requiredDemandsNotFilledIn ? t('notification.error.missingField.demand', 'skallkrav') : ''
          ].filter(x => x);
          NotificationManager.error(
            t('notification.error.requiredField', 'Obligatoriska {{missingFields}} måste fyllas i.', { missingFields })
          );
          this.setState({ processForm: false, supplierPriceDetails, quotationDemands })
          return;
        }
        this.setState({ message: false });
        let formData = {};

        formData.message = getEditorStateContent(quoteMessageContent);
        formData.content = getEditorStateContent(reservationContent);
        formData.supplierId = this.state.supplierId;
        formData.quotationId = this.state.quotationId;
        formData.attachments = JSON.stringify(this.state.files);
        formData.newFiles = this.state.newFiles;
        formData.price = this.state.price;
        formData.quoteVersionNo = this.state.quoteVersionNo;

        formData.supplierPriceDetails = this.state.supplierPriceDetails.map(el => ({
          ...el,
          price: +unformatPrice(el.price || 0),
        }));

        formData.demands = this.state.demands;
        formData.quoteRefId = this.state.quoteRefId;
        formData.quotationValidity = quotationValidity;
        if (this.state.tempSupplierBidFileAreaRoot) {
          formData.fileAreaBidFiles = this.state.tempSupplierBidFileAreaRoot;
        }
        try {
          if (isPublished) {
            const orgId = this.state.projectAreaData.orgId;
            const projectId = this.state.projectData.id;
            const areaId = this.state.projectAreaData._id;
            await ServiceQuotation.saveSalesProjectQuotationBid({
              ...formData,
              orgId,
              projectId,
              areaId,
            });

            if (this.state.newFiles.length > 0) {
              const quotation = await ServiceQuotation.fetchPublicQuotation({
                orgId,
                projectId,
                areaId,
              });
              const correctVersionOfQuotationData = quotation.find(
                quotation => quotation.quoteVersionNo === formData.quoteVersionNo,
              );
              this.setQuotationData(correctVersionOfQuotationData);
            }
          } else {
            await ServiceQuotation.saveProjectQuotationInfo({
              ...formData,
            });

            if (this.state.newFiles.length > 0) {
              let data = await ServiceQuotation.getProjectQuotation(this.state.projectData.slug, this.state.projectAreaData.slug, this.state.supplierId, formData.quoteVersionNo)
              const correctVersionOfQuotationData = data.find(
                quotation => quotation.quoteVersionNo === formData.quoteVersionNo,
              );
              this.setQuotationData(correctVersionOfQuotationData);
            }
          }



          this.setState({
            processForm: false,
            newFiles: [],
            demandsError: '',
            status: {
              ...this.state.status,
              isLocked: true,
              reason: 'Submitted',
              submittedAt: new Date()
            }
          });
          if (this.props.onSubmit) {
            this.props.onSubmit();
          } else {
            NotificationManager.success(t('notification.success.quotationSaved', 'Anbudsformuläret har skickats in'));
          }
        } catch (e) {
          if (e.response.status === 400) {
            const missingMandatoryPriceField = e.response?.data?.error === 'required.price.field.not.provided';
            const missingMandatoryDemand = e.response?.data?.error === 'required.demand.not.provided';
            if (missingMandatoryPriceField || missingMandatoryDemand) {
              const missingFields = [
                requiredPriceFieldsNotFilledIn ? t('notification.error.missingField.priceField', 'prisfält') : '',
                requiredDemandsNotFilledIn ? t('notification.error.missingField.demand', 'skallkrav') : ''
              ].filter(x => x);
              NotificationManager.error(
                t('notification.error.requiredField', 'Obligatoriska {{missingFields}} måste fyllas i.', { missingFields })
              );
            }
          }
          console.log({ e });
        } finally {
          this.setState({ processForm: false });
        }
      };

      const quickPicker = (day, i) => (
        <div
          key={day}
          onClick={() => !isDisabled ? onValidityQuickPick(day) : null}
          className={`quickPicker ${i == 0 ? 'left-border' : ''} ${isDisabled ? 'quickPickerDisabled' : ''}`}
        >
          {day} dagar
        </div>
      );

      const onValidityQuickPick = (day) => {
        let today = new Date();
        let extendedDate = new Date();
        extendedDate.setDate(today.getDate() + day);
        this.setState({ quotationValidity: extendedDate });
      }

      const onChangeQuoteValidity = (date, e) => {
        e.preventDefault();
        this.setState({ quotationValidity: new Date(date) });
      }

      return (
        <div className="quotation-form-container">
          <p className="heading">{t('heading.form', 'Fyll i anbudsformulär')}</p>
          <div className={`form-content ${isDisabled && 'disabledPage'}`}>
            {renderEditor(t('title.message', 'Meddelande'), quoteMessageContent, onQuoteMessageContentChange, true,)}
            {renderEditor(t('title.reservations', 'Reservationer'), reservationContent, onReservationContentChange, false,)}

            {quotationData?.priceDetails?.length > 0 && (
              <div className="quote-price-container">
                {quotationData?.priceDetails?.map(pd => {
                  return (
                    <div key={pd?.priceType?.name} className="quote-price-box">
                      {renderPriceColumn(pd)}
                    </div>
                  );
                })}
              </div>
            )}

            <DemandsContainer>{renderDemands()}</DemandsContainer>

            <div className="quoteValidityContainer">
              <span>{t('title.validity', 'Anbudets giltighetstid')}</span>
              <div className="quoteValidityPickerContainer">
                <label className="pickerIconContainer">
                  <CalendarIcon style={{ fill: 'var(--gray-700)', width: '15px', height: '14px' }} />
                  <DatePicker
                    wrapperClassName="quoteValidity-date-picker-container"
                    dateFormat="yyyy-MM-dd"
                    selected={quotationValidity}
                    onChange={onChangeQuoteValidity}
                    disabled={isDisabled}
                    popperPlacement="top"
                    popperModifiers={{
                      flip: { behavior: ['top'] },
                      preventOverflow: { enabled: false },
                      hide: { enabled: false },
                    }}
                    minDate={new Date()}
                    placeholderText={isDisabled ? '' : t('placeholder.chooseDate', 'Välj datum')}
                  />
                </label>
                {quotationValidityOptions.map(quickPicker)}
              </div>
            </div>

            <BtRow>
              <TooltipContainer
                renderReferenceComponent={(className, ref) => (
                  <div ref={ref} className={className} style={{ width: 'fit-content' }}>
                    <BtButton
                      loaderShow={this.state.processForm}
                      disabled={isDisabled}
                      onClick={!isDisabled ? saveQuotation : undefined}
                    >
                      {t('button.send', 'Skicka')}
                    </BtButton>
                  </div>
                )}
              >
                {this.state.fileAreaUploading && (
                  <div style={{ width: 'max-content', maxWidth: '310px' }}>
                    {t('errorMessage.fileUploading', 'Kan inte skicka: en fil laddas upp.')}
                  </div>
                )}
              </TooltipContainer>
            </BtRow>
          </div>
        </div>
      );
    }

    const onChangeCollapsibleVersion = (data) => {
      this.setState({ openView: !this.state.openView });
      if (!this.state.openView && !isPublished) this.updateQuotationIsSeenStatus(data);
    }

    const quotationDataForQuoteShare = () => {
      const { quoteRefId, quoteVersionNo, supplierId, projectAreaData, projectData, supplierMemberId } = this.state;
      return {
        quoteRefId,
        quoteVersionNo,
        supplierId,
        areaId: projectAreaData?._id,
        projectId: projectData?.id,
        supplierMemberId
      };
    };

    const {
      showBidDeclinedModal,
      previousBidIntent,
      intentStatus,
      bidDeclinedReason,
      supplierMemberId,
      showRequestShareModal,
      supplierMembers,
      fetchingSupplierMembers,
      isSubmittingRejectingIntent,
    } = this.state;

    const isPublishedAndYouAreNotPartOfTheQuotation = this.props.isPublished && this.props.versionData?.supplierMembers.length > 0 && !this.props.versionData?.supplierMembers?.some(m => m.email === appState.getUserEmail());
    const isLockedAndPublishedWhileYouAreNotPartOfTheQuotation = isPublishedAndYouAreNotPartOfTheQuotation && this.props.versionData?.status?.isLocked;

    let bannerTitle = '';
    if (isPublishedAndYouAreNotPartOfTheQuotation) {
      if (this.props.versionData?.status?.isSubmitted) {
        bannerTitle = t('banner.alreadySubmitted', 'Redan inskickad');
      } else {
        bannerTitle = t('banner.notPartOfQuotation', 'Du är inte del av denna förfrågan');
      }
    }
    return (
      <>
        <Collapsible
          onChangeCollapse={() => onChangeCollapsibleVersion(quote)}
          isOpen={openView}
          key={quotation?.id}
          collapsibleClassName="quote-collapsible"
          headerClassName="quote-header-collapsible"
          titleClassName="quote-title-collapsible"
          header={
            <div className="padded-block">
              <div className="title">{t('heading.version', 'Förfrågningsunderlag | Version {{versionNumber}}', { versionNumber })}</div>
              <div className="page-quotation-status-div">
                {!openView && <div className="quote-status">{getStatusMessage(status)}</div>}
                {openView && !isDisabled && !isPublished && renderIntentSelector()}
              </div>
            </div>
          }
        >
          {openView && (
            <div className="generic-card quotation-info-content-container">
              <div className="info-content-container">
                {renderContentBlock2()}
                {renderContentBlock3()}
                {!isLockedAndPublishedWhileYouAreNotPartOfTheQuotation && renderFormContent()}
              </div>
            </div>
          )}

          <Modal
            title={t('declineReason.heading', 'Välj anledning')}
            show={showBidDeclinedModal}
            setShow={value =>
              this.setState({
                showBidDeclinedModal: value,
                intentStatus: !value
                  ? previousBidIntent || BidIntentStatus.UNDECIDED
                  : intentStatus,
              })
            }
            buttonInfo={
              !appState.isReadOnlyAccessRole() && {
                label: t('declineReason.button.add', 'Lägg till'),
                loaderShow: isSubmittingRejectingIntent,
                disabled: !bidDeclinedReason?.label,
                action: async () => {
                  try {
                    this.setState({ isSubmittingRejectingIntent: true });
                    await ServiceQuotation.updateBidIntent(
                      projectData.slug,
                      projectAreaData.slug,
                      supplier._id,
                      parseInt(quoteVersionNo),
                      {
                        intent: intentStatus,
                        reasonDeclined: bidDeclinedReason.label,
                      },
                      supplierMemberId
                    );
                    this.setState({ bidDeclinedReason: null, showBidDeclinedModal: false });
                    NotificationManager.success(t('notification.success.bidIntentSaved', 'Tack! Din avsiktsförklaring är sparad.'));
                  } catch (error) {
                    NotificationManager.error(t('notification.error.unknown', 'Oväntat fel ({{error}})', { error }))
                    throw error;
                  } finally {
                    this.setState({ isSubmittingRejectingIntent: false })
                  }
                },
              }
            }
          >
            {!appState.isReadOnlyAccessRole() && (
              <TitleWrapper title={t('declineReason.label.reason', 'Välj meddelande eller skriv valfri text')} style={{ maxWidth: '490px' }}>
                <Selector
                  isCreatable
                  value={bidDeclinedReason}
                  onChange={value => this.setState({ bidDeclinedReason: value })}
                  options={[
                    {
                      label: t('declineReason.option.noCapacity', 'Har ej kapacitet att utföra jobbet'),
                      value: t('declineReason.option.noCapacity', 'Har ej kapacitet att utföra jobbet')
                    },
                    {
                      label: t('declineReason.option.unclear', 'Omfattning otydlig'),
                      value: t('declineReason.option.unclear', 'Omfattning otydlig')
                    },
                    {
                      label: t('declineReason.option.shortNotice', 'För kort anbudstid'),
                      value: t('declineReason.option.shortNotice', 'För kort anbudstid')
                    },
                    {
                      label: t('declineReason.option.notInterested', 'Ej intresserad'),
                      value: t('declineReason.option.notInterested', 'Ej intresserad')
                    }
                  ]}
                  formatCreateLabel={userInput => t('declineReason.createLabel', 'Skriv "{{userInput}}"', { userInput })}
                  placeholder=""
                />
              </TitleWrapper>
            )}
          </Modal>

          {showRequestShareModal && !appState.isReadOnlyAccessRole() && (
            <QuoteSharingModal
              onClose={this.toggleRequestShareModal}
              supplierMembers={supplierMembers}
              showRequestShareModal={showRequestShareModal}
              getQuotationData={quotationDataForQuoteShare}
              fetchingSupplierMembers={fetchingSupplierMembers}
              allowNewContacts={true}
            />
          )}
        </Collapsible>
        {isPublishedAndYouAreNotPartOfTheQuotation && this.props.openView && <BannerCard title={bannerTitle} style={{ marginBottom: '12px' }}>
          <p style={{ marginTop: 0 }}>{t('banner.contactMembers', 'Kontakta någon av följande personer så att de kan dela offerten med dig:')}</p>
          <ul>
            {this.props.versionData?.supplierMembers?.map(member => (
              <li key={member._id}>{member.name} ({member.email})</li>
            ))}
          </ul>
        </BannerCard>}
      </>
    );
  };

  render() {
    return this.state.quotationData ? this.renderQuotationInfo(this.props.versionData) : null
  }
}

export default withTranslation('quotation', { keyPrefix: 'form' })(CollapsibleView);
